export const MAX_COUNT_WINS = 20;

export const noDataProps = {
	title: 'No Data',
	message: 'Need add words to current folder',
};
